// Chinese translations
const zhTranslations = {
  // Navigation
  counterPicker: '克制选择器',
  winRate: '胜率',
  tierList: '英雄梯队',
  // App.js
  appTitle: 'Marvel Rivals 克制选择器',
  loading: '正在加载 Marvel Rivals 数据...',
  gameSettings: '游戏设置',
  enemyTeam: '敌方队伍',
  alliedTeam: '友方队伍',
  clear: '清除',
  selectEnemyHeroesPrompt: '选择敌方英雄以查看克制推荐',
  dataUpdated: '数据已更新至 Marvel Rivals 版本 20250530',
  counterCalculation: '最佳英雄评分基于克制关系、元数据、地图、段位以及克制敌人的协同效应计算',
  copyright: '© 2025 Marvelrivals.vip - 保留所有权利',
  
  // Disclaimer
  disclaimerTitle: '早期开发声明',
  disclaimerText: '此应用程序目前处于早期开发阶段。由于缺乏全面的比赛数据，我们依靠外部资源获取关键信息：克制策略来源于 peakrivals.com 和社区驱动的主观来源（包括 Reddit 等平台），英雄统计数据来自 mrapi.org。请注意，此处提供的信息并非绝对，不应被视为获胜的保证。成功最终取决于游戏内沟通、战略决策以及您对所选角色的个人技能掌握。请始终根据实时比赛动态调整和完善您的策略。',
  disclaimerButton: '我明白了',
  showDisclaimer: '显示免责声明',
  
  // HeroSelection.js
  selectEnemyTeam: '选择敌方队伍',
  selectAlliedTeam: '选择友方队伍',
  tank: '坦克',
  damage: '伤害',
  support: '辅助',
  vanguard: '先锋',
  duelist: '决斗者',
  strategist: '策略家',
  
  // BannedHeroes.js
  bannedHeroes: '禁用英雄',
  noBannedHeroesYet: '尚未禁用英雄。在下方选择要禁用的英雄。',
  availableHeroes: '可用英雄',
  
  // MapRankSelection.js
  map: '地图',
  anyMap: '任意地图',
  rank: '段位',
  anyRank: '任意段位',
  
  // CounterDisplay.js
  recommendedCounterPicks: '推荐克制选择',
  alternativePicks: '替代选择',
  countersEnemies: '克制',
  counteredBy: '被克制',
  metaRank: '梯队',
  mapBonus: '地图加成',
  synergiesWith: '协同效应',
  yes: '是',
  no: '否',
  alliedTeamRatings: '友方队伍评分',
  and: '和',
  
  // Tabs
  heroSelection: '英雄选择',
  bannedHeroesTab: '禁用英雄',
  
  // Language
  language: '语言',
  english: '英语',
  spanish: '西班牙语',
  chinese: '中文',
  
  // Win Rate Page
  heroWinRates: '英雄胜率',
  filterByRole: '按角色筛选',
  allRoles: '所有角色',
  hero: '英雄',
  role: '角色',
  pickRate: '选取率',
  banRate: '禁用率',
  gameMode: '游戏模式',
  quickPlay: '快速游戏',
  competitive: '竞技模式',
  competitiveRank: '竞技段位',
  competitiveSummary: '所有段位',
  bronze: '青铜',
  silver: '白银',
  gold: '黄金',
  platinum: '铂金',
  diamond: '钻石',
  master: '大师',
  grandmaster: '宗师',
  celestial: '天阶',
  
  // Tier List Page
  heroTierRankings: '英雄梯队排名',
  tierListDescription: '英雄根据其在当前版本中的表现进行排名。',
  tier: '梯队',
  new: '新',
  noHeroesInTier: '该梯队没有英雄'
};

export default zhTranslations;